<template>
  <div
    class="vp-input-box"
    :class="{ dirty }"
  >
    <Textarea
      v-bind="$attrs"
      :input-id="inputId"
    >
      <template #default="{ uid, value, onInput: onTextareaInput }">
        <VPLabel
          v-if="label"
          :for="uid"
          >{{ label }}</VPLabel>
        <textarea
          v-bind="$attrs"
          :id="uid"
          ref="inputRef"
          :disabled="disabled"
          class="vp-textarea"
          :value="value"
          :placeholder="placeholder"
          @input="onTextareaInput"
        />
      </template>
    </Textarea>
  </div>
</template>

<script setup lang="ts">
import { Textarea } from 'vuniform';
import { computed, ref, inject } from 'vue';
import { useFormsStore } from 'vuniform';
import VPLabel from '@/components/form/VPLabel.vue';

const formsStore = useFormsStore();

const formId = inject('formId', '');

const inputRef = ref<HTMLInputElement>(null);

interface Props {
  inputId: string;
  disabled?: boolean;
  placeholder?: string;
  label?: string;
}

const props = defineProps<Props>();

const dirty = computed(() => formsStore.isFieldDirty(formId, props.inputId));

defineExpose({
  inputRef,
});
</script>
